module.exports = __webpack_public_path__ + "media/application/images/svgs/user-x-9ff18507f40aebed603174be99d6b7d7.svg";